<div id="{{CarouselID}}" class="hover-rec mb-3 mb-lg-4">
	<div class="h3 border-bottom border-dark pb-3 mb-4">{{CarouselTitle}}</div>
	<div class="hover-rec__container d-flex justify-content-lg-between" data-personalized="true">
		{{#each Products}}
		<div class="hover-rec__item hover-rec__item--{{@index}} position-relative" data-index="{{@index}}" data-product-id="{{ProductID}}" data-type-id="1">
			<a class="mb-3 mb-lg-0" href="{{Link}}" data-rr-url="{{RRLink}}" tabindex="0">
				<img class="border-0 rounded" loading="lazy" src="{{ImageLinkMedium}}" Height="185" Width="130" alt="{{{Title}}}" />
			</a>
			<div class="hover-rec__info p-lg-3">
				<a class="hover-rec__title fs-xs line-clamp-3 mb-3 mb-lg-0" href="{{Link}}" data-rr-url="{{RRLink}}">{{{Title}}}</a>
				<div class="pricing fs-sm fs-lg-md">
					{{#if HasPriceRange}}
					{{#if IsOnSale}}
					<span class="price price--sale price--rangeSaleMin">
						<span class="visually-hidden">Select sizes on sale. Prices range from&nbsp;</span>
						<span class="low">{{CurrencySymbol}}{{MinPrice}}</span>
						<span class="visually-hidden">&nbsp;to&nbsp;</span>
						<span class="dash">-</span>
						<span class="high">{{CurrencySymbol}}{{MaxPrice}}</span>
					</span>
					{{else}}
					<span class="price price--range">
						<span class="visually-hidden">Prices range from&nbsp;</span>
						<span class="low">{{CurrencySymbol}}{{MinPrice}}</span>
						<span class="visually-hidden">&nbsp;to&nbsp;</span>
						<span class="dash" aria-hidden="true">-</span>
						<span class="high">{{CurrencySymbol}}{{MaxPrice}}</span>
					</span>
					{{/if}}
					{{else}}
					{{#if IsOnSale}}
					<span class="price price--sale"><span class="visually-hidden">Sale Price&nbsp;</span>{{CurrencySymbol}}{{MaxPrice}}</span>
					<span class="price price--strike ms-3"><span class="visually-hidden">Original Price&nbsp;</span><s>{{CurrencySymbol}}{{MaxOriginalPrice}}</s></span>
					{{else}}
					<span class="price">{{CurrencySymbol}}{{MaxPrice}}</span>
					{{/if}}
					{{/if}}
				</div>
				{{#if Rating}}
				<span class="rating-stars" role="image" aria-label="{{RatingDescription}}">
					{{#each Ratings}}
					<svg class="svg-inline--fa" aria-hidden="true">
						<use xlink:href="#{{this}}"></use>
					</svg>
					{{/each}}
				</span>
				{{/if}}
			</div>
		</div>
		{{/each}}
	</div>
</div>